import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { formatPaisa } from '../../../utils/paisa';

/**
 * A ledger figure: two decimals, tabular digits so columns line up, and a
 * quiet dash for zero so the eye lands on real numbers.
 */
const Amount: React.FC<{ paisa: number; blankZero?: boolean } & Omit<TypographyProps, 'children'>> = ({
  paisa, blankZero = true, sx, ...rest
}) => (
  <Typography
    variant="body2"
    component="span"
    color={paisa === 0 && blankZero ? 'text.disabled' : undefined}
    sx={[{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }, ...(Array.isArray(sx) ? sx : [sx])]}
    {...rest}
  >
    {paisa === 0 && blankZero ? '—' : formatPaisa(paisa)}
  </Typography>
);

export default Amount;
